import { taxpayerAuthenticationConfigApi } from '../../api';
import { TaxpayerAuthenticationConfigDTO } from '../../types/hacienda/TaxpayerAuthenticationTypes';

const TaxpayerAuthenticationConfigService = {
    /**
     * Obtiene la configuración activa de autenticación del contribuyente.
     * GET /api/taxpayer-authentication-config
     */
    getConfiguration: async () => {
        const response = await taxpayerAuthenticationConfigApi.fetchAll();
        return response.data;
    },

    /**
     * Crea una nueva configuración de autenticación del contribuyente.
     * POST /api/taxpayer-authentication-config
     */
    createConfiguration: async (data: TaxpayerAuthenticationConfigDTO) => {
        const response = await taxpayerAuthenticationConfigApi.add(data);
        return response.data;
    },

    /**
     * Actualiza la configuración existente.
     * PUT /api/taxpayer-authentication-config/{id}
     */
    updateConfiguration: async (id: number, data: TaxpayerAuthenticationConfigDTO) => {
        const response = await taxpayerAuthenticationConfigApi.modify(id, data);
        return response.data;
    },

    /**
     * ✅ Obtiene el NIT del sistema desde la configuración activa.
     * GET /api/taxpayer-authentication-config/taxpayer-config/system-nit
     */
    getSystemTaxId: async () => {
        const response = await taxpayerAuthenticationConfigApi.fetchCustom('/system-nit');
        return response.data;
    }
};

export default TaxpayerAuthenticationConfigService;
